export const enLottomatica = {
  modal: {
    geolocation: {
      content: 'Lottomatica.it is about to ask you to access your location for better use of the service',
      title: 'Geolocation Lottomatica',
    },
  },
  namespaceTest: 'Hello lottomatica',
};
